import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./home.component";
import { HomeAuthGuard } from "./home-auth-guard.service";
import { DataDetailsComponent } from "./data/data-details.component";
import { SearchGuard } from "./search-guard.service";
import { UploaderComponent } from "./uploader/uploader.component";
import { SearchResultsComponent } from "./search/results/search-results.component";
import { SearchComponent } from "./search/search.component";
import { PatientListingComponent } from "./patient-listing/patient-listing.component";
import { ManageSearchTagsComponent } from "./manage-search-tags/manage-search-tags.component";
import { ManageUsersComponent } from "./manage-users/manage-users.component";
import { ReportsComponent } from "./reports/reports.component";
import { GradingComponent } from "./grading/grading/grading.component";
import { ReportBuilderComponent } from "./report-builder/report-builder.component";
import { CanLeaveGradingGuard } from "./leave-grading-guard.service";
import { ViewableImageComponent } from "./data/viewable-image/viewable-image.component";
import { DataDictionaryComponent } from "./data-dictionary/data-dictionary.component";

const homeRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [HomeAuthGuard],
    children: [
      { path: "", redirectTo: "search", pathMatch: "full" },
      { path: "home", redirectTo: "search", pathMatch: "full" },

      {
        path: "search",
        component: SearchComponent,
        canActivate: [SearchGuard],
      },

      {
        path: "search/results",
        component: SearchResultsComponent,
        canActivate: [SearchGuard],
      },
      {
        path: "data/:dataType/:dataId",
        component: DataDetailsComponent,
        canActivate: [SearchGuard],
      },
      {
        path: "data/viewableImage/:viewableImage",
        component: ViewableImageComponent,
        canActivate: [SearchGuard],
      },
      { path: "uploader", component: UploaderComponent },
      { path: "reports", component: ReportsComponent },
      { path: "reportBuilder", component: ReportBuilderComponent },

      {
        path: "grading/:patientId/:visitId/:studyId",
        component: GradingComponent,
        canDeactivate: [CanLeaveGradingGuard],
      },

      { path: "patientListing", component: PatientListingComponent },

      { path: "admin/searchTags", component: ManageSearchTagsComponent },
      { path: "admin/manageUsers", component: ManageUsersComponent },

      { path: "dataDictionary", component: DataDictionaryComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(homeRoutes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/home/home-routing.module.ts